<div id="photo_gallery_group"  class="ion-content-scroll-host">
    
    @for(photoGroup of this.photosGroups.values(); track $index){
        <div class="photo_gallery_group_operation">
            <div class="photo_gallery_group_operation_header">
                <div>
                    <app-operation-logo [operation]="this.getOperationLogo(photoGroup.operation)" size="medium"/>    
                    <div class="photo_gallery_group_operation_infos">
                        <div>{{photoGroup.operation.name}}</div>
                        <marv-tag [color]="this.missionTypeService.getColor(photoGroup.operation.typeOfMission)" size="small">{{photoGroup.operation.name}}</marv-tag>
                    </div>                     
                    <!--<ion-icon class="button_toggle" [name]="(photoGroup.isOpened ? 'caret-up-outline' : 'caret-down-outline')" (click)="this.toggleOperation(photoGroup.operation)"></ion-icon>-->
                </div>
            </div>
            @if(photoGroup.isOpened){
                <div class="photo_gallery_group_store">
                    @for(photoGroupStore of photoGroup.stores.values(); track $index){
                        <div class="photo_gallery_group_store_header">
                            <div>
                                <app-retailer-logo [retailer]="this.getRetailerLogo(photoGroupStore.retailer)" size="small"/>
                                <div>{{photoGroupStore.store.name}}</div>
                                <!--<ion-icon class="button_toggle" [name]="(photoGroupStore.isOpened ? 'caret-up-outline' : 'caret-down-outline')" (click)="this.toggleStore(photoGroup.operation, photoGroupStore.store)"></ion-icon>-->                    
                            </div>
                        </div>
                        @if(photoGroupStore.isOpened){
                            <div class="photo_gallery_group_photos">
                                @for(photo of photoGroupStore.photos; track $index){
                                    <app-photo-gallery-item [photo]="photo" [size]="this.sizePhoto" [displayStore]="false" [displayOperation]="false" (onSelectPhoto)="this.selectPhoto($event)"/>
                                }
                            </div>
                        }
                    }
                </div>
            }
        </div>
    }
    
    <ion-infinite-scroll (ionInfinite)="this.onIonInfinite($event)" [disabled]="this.disabledInfiniteScroll">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
    </ion-infinite-scroll>
</div>